import React, { useState } from 'react';
import { FaEdit } from 'react-icons/fa';
import { createWallCard } from '../../graphql/mutations';
import { API, graphqlOperation } from 'aws-amplify';

import "./style.sass";

import GreetingFormPanel from './greeting-form-panel';

const GreetingButton = ({wallId, userId, userName}) => {
    const [showModal, setShowModal] = useState(false)
    const [sendStatus, setSendStatus] = useState('')

    const sendGreetingCard = async (cardName, cardMessage) => {
        console.log(`cardName: ${cardName}, cardMessage: ${cardMessage}`)

        setSendStatus('sending')

        const input = {
            text: cardMessage,
            cardName: cardName,
            senderId: userId,
            senderName: userName,
            wallID: wallId
        }

        await API.graphql(graphqlOperation(createWallCard, { input }))
    }

    return (
        <>
            <div className="buttons has-addons is-centered">
                <button className="has-text-weight-bold button is-rounded is-primary is-large"
                    onClick={() => setShowModal(true)}>
                    <FaEdit className="edit-button" /> Greet
                </button>
            </div>

            <GreetingFormPanel
                show={showModal}
                onClose={() => setShowModal(false)}
                sendStatus={sendStatus}
                onSend={(cardName, cardMessage) => sendGreetingCard(cardName, cardMessage)} />
        </>

    )
}

export default GreetingButton;